export const HECO_CHECKOUT_SET_DESIRED_DELIVERY_DATE = 'HECO_CHECKOUT_SET_DESIRED_DELIVERY_DATE';

export const setDesiredDeliveryDate = (desiredDeliveryDate) => ({
    type: HECO_CHECKOUT_SET_DESIRED_DELIVERY_DATE,
    payload: {
        desiredDeliveryDate,
    },
});
